export const AUTH_STORAGE_KEYS = {
  codeVerifier: 'lms_pkce_code_verifier',
  oauthState: 'lms_oauth_state',
  tokens: 'lms_auth_tokens',
} as const;
